import React = require('react');
import { Info } from '../../../components/Info';
import { ICollapsable } from '../../../../../services/quote/models';

interface IAdmiralCardAnswerProps {
  children: any,
  title?: string,
  approvedPositiveText?: string,
  approvedNegativeText?: string,
  icon?: string,
  editMode?: boolean,
  handleEdit?: any,
  handleCollapse?: any,
  infoColor?: 'blue' | 'green',
  infoTextAsBanner?: boolean,
  infoText?: string | any,
  infoTextSuccess?: string,
  noPadding?: boolean,
  answerSelected?: boolean,
  infoModal?: any;
  reverseDisplayAnswers?: boolean;
  shouldAcceptNoAsPositive?: boolean;
  hideHeader?: boolean;
  collapsable?: ICollapsable;
  continueButton?: any;
}

export const AdmiralCardAnswer = ({
                                    children,
                                    icon,
                                    title = '',
                                    approvedPositiveText,
                                    approvedNegativeText,
                                    editMode = true,
                                    handleEdit = null,
                                    infoColor = 'blue',
                                    answerSelected = null,
                                    infoTextAsBanner = true,
                                    infoText = '',
                                    infoTextSuccess = '',
                                    noPadding = false,
                                    infoModal = null,
                                    reverseDisplayAnswers = false,
                                    shouldAcceptNoAsPositive = false,
                                    hideHeader = false,
                                    collapsable,
                                    handleCollapse = null,
                                    continueButton = null,
                                  }: IAdmiralCardAnswerProps) => {

  const renderEditButton = () => {
    return (
      <>
        <div className={'adm-card-edit'} style={{ cursor: 'pointer' }}
             onClick={handleEdit.bind(this, true)}>CHANGE
        </div>
      </>
    )
  }

  const renderSelectedDisplay = () => {
    const iconPositive = require('../../../img/green-tick.svg');
    const iconNegative = require('../../../img/remove.svg');

    const display = (cls: string, icon: string, text: string) => (
      <div>
        <img width={'20px'} src={icon} alt={'Admiral'}/>
        {text}
      </div>
    );

    if (reverseDisplayAnswers) {
      return (
        <>
          {answerSelected === false && display('positive', iconPositive, approvedPositiveText)}
          {answerSelected && display('', iconNegative, approvedNegativeText)}
        </>
      )
    }

    if (shouldAcceptNoAsPositive) {
      return (
        <>
          {answerSelected && display('positive', iconPositive, approvedPositiveText)}
          {answerSelected === false && display('positive', iconPositive, approvedNegativeText)}
        </>
      )
    }

    return (
      <>
        {answerSelected && display('positive', iconPositive, approvedPositiveText)}
        {answerSelected === false && display('', iconNegative, approvedNegativeText)}
      </>
    )
  }

  const renderCardHeader = (isEditable: boolean, showMessage: boolean = false) => {
    return (
      <div className={'adm-card-section-header'}>
        <div className={'title-row'}>
          {icon && (
            <div className={isEditable ? 'adm-icon-circle green ' : 'adm-icon-circle'}>
              <img src={require(`../../../img/${icon}`)} alt={''}/>
            </div>
          )}
          <div className={'adm-card-title'}>
            <h3>
              {title}
            </h3>
          </div>
          {isEditable && (
            <>
              <div className={'adm-card-edit'} style={{ cursor: 'pointer' }}
                   onClick={handleCollapse}>CHANGE
              </div>
              <img src={require('../../../img/edit.svg')} alt={'admiral'}/>
            </>
          )}
        </div>
        {showMessage && (
          <div className={'message'}>
            {renderSelectedDisplay()}
          </div>
        )}
      </div>
    )
  }

  const renderInfoText = () => {
    if (!infoColor || !infoText) return (<></>);

    let text = infoText;
    let color = infoColor;
    if ((shouldAcceptNoAsPositive && !answerSelected) || (!shouldAcceptNoAsPositive && answerSelected)) {
      text = infoTextSuccess;
      color = 'green';
    }
    return infoTextAsBanner ?
      (<Info text={text} color={color}/>) :
      (<div className={'text-info'}>{infoText}</div>);
  }

  if (collapsable?.opened === false) {
    return (
      <div className={'adm-card-answer'}>
        {renderCardHeader(collapsable?.isEditable, true)}
      </div>
    )
  }

  return (
    <div className={'adm-card-answer'}>
      {infoModal && (<div>{infoModal}</div>)}
      {!hideHeader && renderCardHeader(false, false)}
      {renderInfoText()}
      {editMode && (
        <>
          <div className={noPadding ? 'adm-card-section-body no-padding' : 'adm-card-section-body'}>
            {children}
          </div>
        </>
      )}
      {!editMode && (
        <>
          <div className={noPadding ? 'adm-card-section-body no-padding' : 'adm-card-section-body'}>
            {children}
          </div>

          <div className={'selected-answer-display-container'}>
            <div className={'box--90 text'}>
              {renderSelectedDisplay()}
            </div>
            <div className={'box--10 edit'}>
              {renderEditButton()}
            </div>
          </div>

        </>
      )}
      {continueButton && continueButton()}
    </div>
  )
}
